import { render } from "./DsoStep4Registration.vue?vue&type=template&id=53b20451&scoped=true"
import script from "./DsoStep4Registration.vue?vue&type=script&lang=js"
export * from "./DsoStep4Registration.vue?vue&type=script&lang=js"

import "./DsoStep4Registration.vue?vue&type=style&index=0&id=53b20451&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b20451"]])

export default __exports__